module.exports = __webpack_public_path__ + "assets/img/dishes1.8863d9e0.png";